import React from 'react';

export const isCtrlKey = <T>(event: MouseEvent | React.MouseEvent<T>) =>
  event.ctrlKey || event.metaKey;
